<template>
  <el-dialog
    :title="`设备号关联详情 - ${deviceNo}`"
    :visible="visible"
    append-to-body
    width="80%"
    :close-on-click-modal="false"
    class="page-dialog center-dialog"
    @update:visible="val => $emit('update:visible', val)"
    @closed="handleClosed"
  >
    <SchemaTablePage
      style="height: 600px"
      ref="tablePageRef"
      layout-mode="dialog"
      :immediate="false"
      :search-schema="[]"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
      :table-attrs="tableAttrs"
    >
      <template #colAccount="{ row }">
        <MemberAccountCell
          :row="row"
          :username="row.username"
          :uid="row.uid"
          :vip-level="row.vip_level"
          :clickable="false"
          :enable-detail-dialog="false"
        />
      </template>
      <template #colStatus="{ row }">
        <el-tag size="small" :type="row.inviter_status === 1 ? 'success' : 'danger'">{{
          row.inviter_status === 1 ? '启用' : '禁用'
        }}</el-tag>
      </template>
      <template #colAgentBackGold="{ row }">
        {{ formatAmount(row.agent_back_gold) }}
      </template>
      <template #colShareGoldToInviter="{ row }">
        {{ formatAmount(row.share_two_gold_to_inviter + row.share_one_gold_to_inviter) }}
      </template>
      <template #colTotalPayinAmount="{ row }">
        {{ formatAmount(row.total_payin_amount) }}
      </template>
      <template #colTotalBetAmount="{ row }">
        {{ formatAmount(row.total_bet_amount) }}
      </template>
      <template #colIp="{ row }">
        {{ ip }}
      </template>
    </SchemaTablePage>
  </el-dialog>
</template>

<script>
import { getAgentPlayerByDeviceIp } from '@/api/riskControl/loginLog.js'
import SchemaTablePage from '@/components/SchemaTablePage'
import MemberAccountCell from '@/components/MemberAccountCell.vue'
import { centsToYuan } from '@/utils/amount'

export default {
  name: 'ManageDeviceDetailDialog',
  components: { SchemaTablePage, MemberAccountCell },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    deviceNo: {
      type: String,
      default: '',
    },
    ip: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableAttrs: { maxHeight: 500 },
      defaultQuery: {},
      tableColumns: [
        { prop: 'account', label: '账号信息', minWidth: 170, resizable: false, slot: 'colAccount' },
        { prop: 'inviter_username', label: '上级代理', minWidth: 120, resizable: false },
        { prop: 'share_num', label: '直属下级人数', minWidth: 110, resizable: false, align: 'center' },
        { prop: 'agent_back_gold', label: '已获得佣金', minWidth: 110, resizable: false, slot: 'colAgentBackGold' },
        { prop: 'total_payin_amount', label: '累计存款', minWidth: 110, resizable: false, slot: 'colTotalPayinAmount' },
        { prop: 'total_bet_amount', label: '累计下注', minWidth: 110, resizable: false, slot: 'colTotalBetAmount' },
        {
          prop: 'share_gold_to_inviter',
          label: '贡献佣金',
          minWidth: 110,
          resizable: false,
          slot: 'colShareGoldToInviter',
        },
        {
          prop: 'inviter_status',
          label: '会员状态',
          minWidth: 100,
          resizable: false,
          slot: 'colStatus',
          align: 'center',
        },
        { prop: 'ip', label: '登录IP', minWidth: 130, resizable: false, slot: 'colIp' },
      ],
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.tablePageRef?.reload?.()
        })
      }
    },
  },
  methods: {
    formatAmount(v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return String(v)
      return centsToYuan(n)
    },
    request(params) {
      return getAgentPlayerByDeviceIp(params)
    },
    buildParams({ page, limit }) {
      return {
        device: this.deviceNo,
        page,
        page_size: limit,
      }
    },
    parseResult(response) {
      return {
        list: response?.data?.list || [],
        total: response?.data?.total || 0,
      }
    },

    // 取消
    handleCancel() {
      this.$emit('update:visible', false)
    },

    // 弹窗关闭回调
    handleClosed() {
      // 通知父组件弹窗已关闭
      this.$emit('closed')
    },
  },
}
</script>

<style scoped>
.dialog-content {
  padding: 0 0 20px 0;
}
</style>
